import { LoginCallback as OktaLoginCallback } from '@okta/okta-react';
import { LoadingIndicator } from '@triumph/design-system';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PageRoutes } from '../../components/router/routes';

const StyledContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
`;

export const LoginCallback = () => {
    const { t } = useTranslation('redirect');
    const navigate = useNavigate();

    const onAuthResume = () => {
        navigate(PageRoutes.LOGIN);
    };

    return <OktaLoginCallback
        onAuthResume={onAuthResume}
        loadingElement={
            <StyledContainer>
                <LoadingIndicator
                    show={true}
                    message={`${t('redirecting')}...`}
                    contained={true}
                    delay={1}
                />
            </StyledContainer>
        }
    />;
};